import { render, staticRenderFns } from "./PictureAndVideoShow.vue?vue&type=template&id=3f6bb3bb&"
import script from "./PictureAndVideoShow.vue?vue&type=script&lang=js&"
export * from "./PictureAndVideoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports